<cm-page *ngIf="generation">
  <h1 slot="header">Generation details for {{ generation.name }}</h1>
  <cm-page-tab label="Generation Details">
    <generation-details></generation-details>
  </cm-page-tab>
</cm-page>
